import { useState } from "react";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { Calculator, ArrowRight, Loader2 } from "lucide-react";

export const PriceEstimator = () => {
  const [f, setF] = useState({ von: "", nach: "", volumen: 4 });
  const [res, setRes] = useState(null);
  const [busy, setBusy] = useState(false);
  const run = async () => {
    if (!f.von || !f.nach) return;
    setBusy(true);
    try { const { data } = await api.get("/public/price-estimate", { params: f }); setRes(data); } catch { setRes(null); }
    setBusy(false);
  };
  return (
    <div className="eb-card p-5 lg:p-6" data-testid="price-estimator">
      <div className="flex items-center gap-2 mb-4"><Calculator className="w-4 h-4 text-[#FF5A1F]" /><h3 className="font-head font-semibold">Preis-Schätzer</h3><span className="text-xs text-slate-500 ml-auto">unverbindlich</span></div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        <div><label className="eb-label">Von</label><input className="eb-input mt-1.5" placeholder="Ort" value={f.von} onChange={(e) => setF({ ...f, von: e.target.value })} data-testid="estimate-von" /></div>
        <div><label className="eb-label">Nach</label><input className="eb-input mt-1.5" placeholder="Ort" value={f.nach} onChange={(e) => setF({ ...f, nach: e.target.value })} data-testid="estimate-nach" /></div>
        <div><label className="eb-label">Volumen m³</label><input type="number" min="0.5" step="0.5" className="eb-input mt-1.5" value={f.volumen} onChange={(e) => setF({ ...f, volumen: e.target.value })} data-testid="estimate-volumen" /></div>
        <div className="flex items-end"><button onClick={run} disabled={busy || !f.von || !f.nach} className="eb-btn-primary w-full" data-testid="estimate-btn">{busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Preis schätzen"}</button></div>
      </div>
      {res && (
        <div className="mt-5 rounded-lg border border-slate-800 bg-[#0B0F17] p-4 flex flex-wrap items-center gap-4" data-testid="estimate-result">
          <div>
            <div className="eb-label">Preisspanne {res.von} → {res.nach}, {res.volumen} m³</div>
            <div className="font-head text-2xl sm:text-3xl font-bold text-[#FF5A1F] mt-1" data-testid="estimate-range">{res.low} – {res.high} €</div>
            <div className="text-xs text-slate-500 mt-1">{res.matching_trips > 0 ? `${res.matching_trips} passende Fahrt(en) aktuell verfügbar${res.next_departure ? ` · nächste Abfahrt ${res.next_departure}` : ""}` : "Richtwert – aktuell keine passende Fahrt gelistet"}{res.distance_km ? ` · ca. ${res.distance_km} km` : ""}</div>
          </div>
          <Link to={`/anfrage?von=${encodeURIComponent(res.von)}&nach=${encodeURIComponent(res.nach)}&volumen=${res.volumen}`} className="eb-btn-outline ml-auto" data-testid="estimate-request-btn">Anfrage stellen <ArrowRight className="w-4 h-4" /></Link>
        </div>
      )}
    </div>
  );
};
